export default __webpack_public_path__ + "static/media/pinkTheme-girl.50c0c02f.svg";